export default __webpack_public_path__ + "static/media/OUTSTANDINGPAYMENT.adb45f27.png";